export const LLM_THREAD_CAPABILITY_OPTIONS = [
  { value: "responses", label: "Chat" },
  { value: "audio_transcription", label: "Transcribe audio" },
  { value: "audio_translation", label: "Translate audio" },
  { value: "audio_speech", label: "Generate speech" },
  { value: "image_generation", label: "Generate image" }
];

const IMAGE_INPUT_ACCEPT = "image/png,image/jpeg,image/webp";
const AUDIO_INPUT_ACCEPT = "audio/mpeg,audio/mp4,audio/x-m4a,audio/wav,audio/webm,audio/ogg";

export function normalizeInferenceCapability(value) {
  const capability = String(value || "").trim();
  return capability || "responses";
}

export function inferenceCapabilityPromptLabel(capability) {
  switch (normalizeInferenceCapability(capability)) {
  case "embeddings":
    return "Input";
  case "audio_speech":
    return "Input text";
  default:
    return "Prompt";
  }
}

export function inferenceCapabilityPromptPlaceholder(capability) {
  switch (normalizeInferenceCapability(capability)) {
  case "responses":
    return "Message...";
  case "embeddings":
    return "Text to embed...";
  case "image_generation":
    return "Describe the image...";
  case "audio_speech":
    return "Enter text to speak...";
  case "audio_transcription":
    return "Hint for transcription (optional)...";
  case "audio_translation":
    return "Hint for translation (optional)...";
  default:
    return "Enter your message...";
  }
}

export function inferenceCapabilitySupportsStream(capability) {
  return normalizeInferenceCapability(capability) === "responses";
}

export function inferenceCapabilityRequiresFileUpload(capability) {
  return inferenceCapabilityMediaKind(capability) === "audio";
}

export function inferenceCapabilityMediaKind(capability) {
  switch (normalizeInferenceCapability(capability)) {
  case "responses":
    return "image";
  case "audio_transcription":
  case "audio_translation":
    return "audio";
  default:
    return "";
  }
}

export function inferenceCapabilityAttachmentInputType(capability) {
  switch (inferenceCapabilityMediaKind(capability)) {
  case "image":
    return "input_image_attachment";
  case "audio":
    return "input_audio_attachment";
  default:
    return "";
  }
}

export function inferenceCapabilitySupportsContextRefs(capability) {
  return normalizeInferenceCapability(capability) === "responses";
}

export function inferenceCapabilityFileInputName(capability) {
  switch (inferenceCapabilityMediaKind(capability)) {
  case "image":
    return "images";
  case "audio":
    return "audio";
  default:
    return "";
  }
}

export function inferenceCapabilityFileAccept(capability) {
  switch (inferenceCapabilityMediaKind(capability)) {
  case "image":
    return IMAGE_INPUT_ACCEPT;
  case "audio":
    return AUDIO_INPUT_ACCEPT;
  default:
    return "";
  }
}
